import { useLocation } from "react-router-dom";

import useInviteQueryParamsValid from "features/teachers/features/class-sharing/hooks/useInviteQueryParamsValid";

export function useIsTeacherClassInviteSignIn() {
  const location = useLocation();

  const inviteQueryParamsAreValid = useInviteQueryParamsValid(location);

  return inviteQueryParamsAreValid;
}
